export default __webpack_public_path__ + "static/decoration-01-sp-7c49c6d8b9bccf4fb232cdc214f61631.svg";